import { useCallback, useState } from 'react';

type SubmitGuardProps = {
  onSubmit: () => Promise<void>;
};

export const useSubmitState = ({ onSubmit }: SubmitGuardProps) => {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const submit = useCallback(async () => {
    try {
      setIsSubmitting(true);
      await onSubmit();
    } finally {
      setIsSubmitting(false);
    }
  }, [onSubmit]);

  return { isSubmitting, submit };
};
